import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGrid = styled.div.withConfig({
  displayName: "Grid__StyledGrid",
  componentId: "sc-16up3bd-0"
})(({
  $spaceStyles,
  theme: _theme
}) => {
  const theme = _theme;
  return Object.assign({
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    marginInlineStart: `-${theme.space[400]}`,
    marginInlineEnd: `-${theme.space[400]}`
  }, $spaceStyles);
});
export const Grid = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const spaceStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledGrid, Object.assign({
    $spaceStyles: spaceStyles
  }, domProps, {
    children: children
  }));
};